/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import React, { useContext, useEffect, useRef, useState } from 'react';
import { useForm } from 'react-hook-form';
import { invoiceClasses } from '../themes';
import { useSuppliers, useTemplate } from '../hooks';
import {
  dublicateAlert,
  errorAlert,
  messageAlert,
  moneyFormat,
} from '../Shared';
import { GContextTypes } from '../types';
import { GlobalContext } from '../contexts';
import { Box, TextField, Typography } from '@material-ui/core';
import ItemsTable from '../Shared/ItemsTable';
import { PriceTotal } from '../Shared/TotalPrice';
import { operationTypes } from '../constants';
import { accountCode, parents } from '../constants/kaid';
import PopupLayout from '../pages/main/PopupLayout';
import { Grid } from '@material-ui/core';
import AutoFieldLocal from '../components/fields/AutoFieldLocal';
import { CalenderLocal } from '../components';
import PopupSupplier from './PopupSupplier';
import _ from 'lodash';
import useTasks from '../hooks/useTasks';
import PopupDeprtment from './PopupDeprtment';
import PopupEmployee from './PopupEmployee';
import PopupResourses from './PopupResourses';
import useDepartments from '../hooks/useDepartments';
import useEmployees from '../hooks/useEmployees';
import useResourses from '../hooks/useResourses';
import { weekdaysNNo } from '../constants/datatypes';
import { useReactToPrint } from 'react-to-print';
import { successAlert } from '../Shared/helpers';
import ServiceItemForm from '../Shared/ServiceItemForm';
import { getDefaultTemplate, tafkeet } from '../common/helpers';
import usePrintTemplates from '../hooks/usePrintTemplates';
import PrintDownload from '../Shared/PrintDownload';
import useCompany from '../hooks/useCompany';
import { userroles } from '../common';

import PaymentSelect from '../pages/options/PaymentSelect';
import useAccounts from '../hooks/useAccounts';

export const indexTheList = (list: any) => {
  return list.map((item: any, index: any) => {
    return {
      ...item,
      index,
    };
  });
};

const PopupPurchaseInvoice = ({
  open,
  onClose,
  row,
  isNew,
  addAction,
  editAction,
  resourses,
  employees,
  departments,
  servicesproducts,
  theme,
  task,
  value,
  name,
}: any) => {
  const classes = invoiceClasses();
  const [saving, setSaving] = useState(false);
  const { tasks } = useTasks();

  const [alrt, setAlrt] = useState({ show: false, msg: '', type: undefined });
  const [selectedDate, setSelectedDate] = React.useState(null);
  const [invNo, setInvNo] = useState<any>('');

  const [itemsList, setItemsList] = useState<any>([]);
  const [accounts, setAccounts] = useState<any>([]);

  const [isCash, setIsCash] = useState(false);
  const [paid, setPaid] = useState<any>(0);
  const [payAcc, setPayAcc]: any = React.useState(null);
  const [desc, setDesc] = useState(null);

  const [discount, setDiscount] = useState(0);
  const [totals, setTotals] = useState<any>({});

  const [departvalue, setDepartvalue] = useState<any>(
    name === 'departmentId' ? value : null
  );
  const [departError, setDepartError] = useState<any>(false);
  const departRef: any = React.useRef();

  const [emplvalue, setEmplvalue] = useState<any>(
    name === 'employeeId' ? value : null
  );
  const [emplError, setEmplError] = useState<any>(false);
  const emplRef: any = React.useRef();

  const [resovalue, setResovalue] = useState<any>(
    name === 'resourseId' ? value : null
  );
  const [resoError, setResoError] = useState<any>(false);
  const resoRef: any = React.useRef();

  const [suppvalue, setSuppvalue] = useState<any>(
    name === 'supplierId' ? value : null
  );

  const [taskvalue, setTaskvalue] = useState<any>(
    name === 'contractId' ? value : null
  );
  const [newtext, setNewtext] = useState('');

  const [openSupp, setOpenSupp] = useState(false);
  const [openDep, setOpenDep] = useState(false);
  const [openEmp, setOpenEmp] = useState(false);
  const [openRes, setOpenRes] = useState(false);
  const { accounts: mainAccounts } = useAccounts();

  const { suppliers, addSupplier, editSupplier } = useSuppliers();
  const { addDepartment, editDepartment } = useDepartments();
  const { addEmployee, editEmployee } = useEmployees();
  const { addResourse, editResourse } = useResourses();
  const { tempwords, tempoptions } = useTemplate();
  const { printtemplates } = usePrintTemplates();
  const { company } = useCompany();

  const {
    translate: { words, isRTL },
    store: { user },
  }: GContextTypes = useContext(GlobalContext);

  const isemployee = user?.isEmployee && user?.employeeId;

  const openDepartment = () => {
    setOpenDep(true);
  };
  const onCloseDepartment = () => {
    setOpenDep(false);
    setNewtext('');
  };
  const openEmployee = () => {
    setOpenEmp(true);
  };
  const onCloseEmploee = () => {
    setOpenEmp(false);
    setNewtext('');
  };
  const openResourse = () => {
    setOpenRes(true);
  };
  const onCloseResourse = () => {
    setOpenRes(false);
    setNewtext('');
  };

  const openSupplier = () => {
    setOpenSupp(true);
  };
  const onCloseSupplier = () => {
    setOpenSupp(false);
    setNewtext('');
  };
  const onNewSuppChange = (nextValue: any) => {
    setSuppvalue(nextValue);
  };
  const onNewDepartChange = (nextValue: any) => {
    setDepartvalue(nextValue);
  };
  const onNewEmplChange = (nextValue: any) => {
    setEmplvalue(nextValue);
  };
  const onNewResoChange = (nextValue: any) => {
    setResovalue(nextValue);
  };

  useEffect(() => {
    if (isemployee) {
      const emp = employees.filter(
        (em: any) => em._id === user.employeeId
      )?.[0];
      setEmplvalue(emp);
    }
  }, [user, employees]);

  useEffect(() => {
    if (isNew && !isemployee) {
      if (taskvalue) {
        if (taskvalue?.departmentId && name !== 'departmentId') {
          const dept = departments.filter(
            (dep: any) => dep._id === taskvalue?.departmentId
          )?.[0];
          setDepartvalue(dept);
        }
        if (taskvalue?.employeeId && name !== 'employeeId') {
          const emp = employees.filter(
            (dep: any) => dep._id === taskvalue?.employeeId
          )?.[0];
          setEmplvalue(emp);
        }
        if (taskvalue?.resourseId && name !== 'resourseId') {
          const res = resourses.filter(
            (dep: any) => dep._id === taskvalue?.resourseId
          )?.[0];
          setResovalue(res);
        }
        if (taskvalue?.supplierId && name !== 'supplierId') {
          const cust = suppliers.filter(
            (dep: any) => dep._id === taskvalue?.supplierId
          )?.[0];
          setSuppvalue(cust);
        }
      }
    }
  }, [taskvalue]);

  const { handleSubmit, reset } = useForm({});

  const resetAllForms = () => {
    reset();
    setItemsList([]);
    setDiscount(0);
    setTotals({});
    setInvNo('');
    setAccounts([]);
    setIsCash(false);
    setSelectedDate(new Date());
    setSuppvalue(name === 'supplierId' ? value : null);
    setDepartvalue(name === 'departmentId' ? value : null);
    setEmplvalue(name === 'employeeId' ? value : null);
    setResovalue(name === 'resourseId' ? value : null);
    setTaskvalue(name === 'contractId' ? value : null);
    setPaid(0);
    setPayAcc(null);
    setDesc(null);
  };
  const addItemToList = (item: any) => {
    const newArray = [...itemsList, { ...item }];
    const listwithindex = indexTheList(newArray);
    setItemsList(listwithindex);
  };
  const editItemInList = (item: any) => {
    const newArray = itemsList.map((it: any) => {
      if (it?.index === item?.index) {
        return item;
      } else {
        return it;
      }
    });
    const listwithindex = indexTheList(newArray);
    setItemsList(listwithindex);
  };

  const removeItemFromList = (index: any) => {
    const newList = [...itemsList];
    newList.splice(index, 1);
    const listwithindex = indexTheList(newList);
    setItemsList(listwithindex);
  };

  const handleDateChange = (date: any) => {
    if (date) {
      const d = new Date(date);
      d?.setHours(8, 0, 0);
      setSelectedDate(d);
    }
  };

  useEffect(() => {
    if (isNew) {
      if (name === 'contractId') {
        if (value?.departmentId) {
          const dept = departments.filter(
            (dep: any) => dep._id === value?.departmentId
          )?.[0];
          setDepartvalue(dept);
        }
        if (value?.employeeId) {
          const dept = employees.filter(
            (dep: any) => dep._id === value?.employeeId
          )?.[0];
          setEmplvalue(dept);
        }
        if (value?.resourseId) {
          const dept = resourses.filter(
            (dep: any) => dep._id === value?.resourseId
          )?.[0];
          setResovalue(dept);
        }
        if (value?.supplierId) {
          const dept = suppliers.filter(
            (dep: any) => dep._id === value?.supplierId
          )?.[0];
          setSuppvalue(dept);
        }
      }
    }
  }, [open]);

  useEffect(() => {
    getOverallTotal();
  }, [itemsList, discount, isCash, paid, payAcc]);

  useEffect(() => {
    if (row && row._id) {
      const _id = row.supplierId;
      const supp = suppliers.filter((it: any) => it._id === _id)[0];

      const depId = row.departmentId;
      const empId = row.employeeId;
      const resId = row.resourseId;
      if (depId) {
        const depart = departments.filter((dep: any) => dep._id === depId)[0];
        setDepartvalue(depart);
      }
      if (empId) {
        const empl = employees.filter((emp: any) => emp._id === empId)[0];
        setEmplvalue(empl);
      }
      if (resId) {
        const empl = resourses.filter((emp: any) => emp._id === resId)[0];
        setResovalue(empl);
      }

      if (!task && row.contractId) {
        const tsk = tasks.filter((ts: any) => ts._id === row.contractId)[0];
        setTaskvalue(tsk);
      }
      if (row?.amountPaid) {
        setPaid(row?.amountPaid);
      }
      if (row?.payAcc) {
        const pay = mainAccounts.filter(
          (acc: any) => acc.code === row?.payAcc
        )?.[0];
        setPayAcc(pay);
      }

      setSuppvalue(supp);
      setIsCash(row.isCash);
      setDiscount(row.discount);
      setInvNo(row.docNo);
      handleDateChange(row.time);
      setDesc(row?.desc);
      setItemsList(row?.items);
    }
  }, [row]);

  useEffect(() => {
    if (isNew) {
      const start = new Date();
      start.setHours(8, 0, 0);
      setSelectedDate(start);
    }
  }, [open]);

  const getOverallTotal = () => {
    const sum = _(itemsList).sumBy('total');

    const amount = sum - discount;
    const tots = {
      total: sum,
      amount,
    };
    setTotals(tots);

    const accs = [
      {
        debitAcc: accountCode.cost_of_sales,
        creditAcc: accountCode.accounts_payable,
        // amount: sum, // sum nunstockitem
        amount: totals.total, // non stock items
        type: operationTypes.purchaseInvoice,
      },
      {
        debitAcc: accountCode.accounts_payable,
        creditAcc: accountCode.cost_of_sales,
        amount: discount,
        type: operationTypes.supplierDiscount,
      },
      {
        debitAcc: accountCode.accounts_payable,
        creditAcc: payAcc ? payAcc.code : accountCode.cash_on_hand,
        amount: isCash ? paid : 0,
        type: operationTypes.supplierPayemnt,
      },
    ];
    setAccounts(accs);
  };

  const onSubmit = async () => {
    if (!suppvalue) {
      await messageAlert(
        setAlrt,
        isRTL ? 'يرجى اضافة مورد للفاتورة' : 'Please add Supplier'
      );
      return;
    }
    setSaving(true);
    const { amount, total, costAmount } = totals;
    const items = JSON.stringify(itemsList);

    const variables: any = {
      _id: row && row._id ? row._id : undefined, // is it new or edit
      time: selectedDate,
      supplier: {
        supplierId: suppvalue._id,
        supplierName: suppvalue.name,
        supplierNameAr: suppvalue.nameAr,
        supplierPhone: suppvalue.phone,
      },
      department: departvalue
        ? {
            departmentId: departvalue._id,
            departmentName: departvalue.name,
            departmentNameAr: departvalue.nameAr,
            departmentColor: departvalue.color,
          }
        : {
            departmentId: undefined,
            departmentName: undefined,
            departmentNameAr: undefined,
            departmentColor: undefined,
          },
      employee: emplvalue
        ? {
            employeeId: emplvalue._id,
            employeeName: emplvalue.name,
            employeeNameAr: emplvalue.nameAr,
            employeeColor: emplvalue.color,
            employeePhone: emplvalue.phone,
          }
        : {
            employeeId: undefined,
            employeeName: undefined,
            employeeNameAr: undefined,
            employeeColor: undefined,
            employeePhone: undefined,
          },
      resourse: resovalue
        ? {
            resourseId: resovalue._id,
            resourseName: resovalue.name,
            resourseNameAr: resovalue.nameAr,
            resourseColor: resovalue.color,
          }
        : {
            resourseId: undefined,
            resourseName: undefined,
            resourseNameAr: undefined,
            resourseColor: undefined,
          },
      contract: taskvalue
        ? {
            contractId: taskvalue._id,
            contractName: taskvalue.name,
            contractNameAr: taskvalue.nameAr,
          }
        : {
            contractId: undefined,
            contractName: undefined,
            contractNameAr: undefined,
          },
      project: taskvalue
        ? {
            projectId: taskvalue.projectId,
            projectName: taskvalue.projectName,
            projectNameAr: taskvalue.projectNameAr,
          }
        : {
            projectId: undefined,
            projectName: undefined,
            projectNameAr: undefined,
          },
      items,
      costAmount,
      total,
      discount,
      amount,
      isPaid: isCash,
      isCash,
      amountPaid: isCash ? paid : 0,
      payAcc: isCash && payAcc ? payAcc.code : undefined,
      accounts,
      desc,
      userId: user._id,
    };
    const mutate = isNew ? addAction : editAction;
    apply(mutate, variables);
  };

  const apply = async (mutate: any, variables: any) => {
    try {
      await mutate({ variables });
      await successAlert(setAlrt, isRTL);
      setSaving(false);
      onCloseForm();
    } catch (error) {
      onError(error);
      console.log(error);
    }
  };

  const onError = async (error: any) => {
    if (error.message.includes('duplicate')) {
      await dublicateAlert(setAlrt, isRTL);
    } else {
      await errorAlert(setAlrt, isRTL);
      reset();
      console.log(error);
    }
  };

  const onCloseForm = () => {
    resetAllForms();
    onClose();
  };

  const onHandleSubmit = () => {
    handleSubmit(onSubmit)();
  };

  const componentRef: any = useRef();
  const handleReactPrint = useReactToPrint({
    content: () => componentRef.current,
    documentTitle: `Invoice #${row?.docNo}`,
    removeAfterPrint: true,
  });

  const printData = {
    invoiceNo: invNo,
    time: selectedDate,
    docNo: invNo,
    supplierName: suppvalue?.name,
    supplierPhone: suppvalue?.phone,
    supplierNameAr: suppvalue?.nameAr,
    total: totals.total,
    discount,
    amount: totals.amount,
    items: itemsList,
    user: user?.name,
    tafkeet: tafkeet(totals.amount, isRTL),
  };

  const template = getDefaultTemplate(printtemplates, 'purchase');
  const cashaccounts = mainAccounts.filter(
    (acc: any) => acc.parentcode === parents.CASH
  );
  const date = row?.startDate ? new Date(row?.startDate) : new Date();
  const day = weekdaysNNo?.[date.getDay()];

  const title = isRTL ? 'فاتورة شراء' : 'Purchase Invoice';

  const bl = totals?.amount - paid;
  const pa = `${paid} /  ${totals?.amount}`;

  return (
    <PopupLayout
      isRTL={isRTL}
      open={open}
      onClose={onCloseForm}
      title={title}
      saving={saving}
      onSubmit={onHandleSubmit}
      theme={theme}
      alrt={alrt}
      // print={!isNew ? handleReactPrint : undefined}
      onlyclose={!isNew && !userroles?.purchase?.edit}
      maxWidth="lg"
      mt={0}
      mb={40}
    >
      <Grid container spacing={1}>
        <Grid item xs={4}>
          <Box display={'flex'}>
            <CalenderLocal
              isRTL={isRTL}
              label={words?.time}
              value={selectedDate}
              onChange={handleDateChange}
            ></CalenderLocal>
            {!isNew && (
              <Box
                display="flex"
                style={{
                  flex: 1,
                  flexDirection: isRTL ? 'row-reverse' : 'row',
                  alignItems: 'center',
                  justifyContent: 'flex-end',
                  marginTop: 32,
                }}
              >
                <TextField
                  name="invNo"
                  disabled
                  value={invNo}
                  variant="outlined"
                  style={{
                    width: isNew ? 70 : 100,
                    marginLeft: 20,
                    marginRight: 20,
                  }}
                  margin="dense"
                  inputProps={{
                    style: {
                      textAlign: 'center',
                      fontSize: 14,
                      height: 13,
                    },
                  }}
                />
              </Box>
            )}
          </Box>
        </Grid>
        <Grid item xs={12} md={8}>
          <PrintDownload
            company={company}
            printData={printData}
            template={template}
            componentRef={componentRef}
            handleReactPrint={handleReactPrint}
            no={row?.docNo}
            element="invoice"
            isRTL={isRTL}
            isNew={isNew}
          ></PrintDownload>
        </Grid>
        <Grid item xs={8}>
          <Grid container spacing={1}>
            <Grid item xs={12}>
              <AutoFieldLocal
                name="supplier"
                title={words.supplier}
                words={words}
                options={suppliers}
                value={suppvalue}
                setSelectValue={setSuppvalue}
                isRTL={isRTL}
                fullWidth
                openAdd={openSupplier}
                showphone
                disabled={name === 'supplierId'}
              ></AutoFieldLocal>
            </Grid>
            {tempoptions?.docrelations &&
              !tempoptions?.purchaseitemrelations && (
                <>
                  {tempoptions?.contract && (
                    <Grid item xs={6}>
                      <AutoFieldLocal
                        name="task"
                        title={tempwords?.task}
                        words={words}
                        options={tasks}
                        value={taskvalue}
                        setSelectValue={setTaskvalue}
                        isRTL={isRTL}
                        fullWidth
                        disabled={name === 'contractId'}
                      ></AutoFieldLocal>
                    </Grid>
                  )}
                  {tempoptions?.employee && (
                    <Grid item xs={6}>
                      <AutoFieldLocal
                        name="employee"
                        title={tempwords?.employee}
                        words={words}
                        options={employees.filter((emp: any) => !emp.disabled)}
                        value={emplvalue}
                        disabled={isemployee || name === 'employeeId'}
                        setSelectValue={setEmplvalue}
                        setSelectError={setEmplError}
                        selectError={emplError}
                        refernce={emplRef}
                        openAdd={openEmployee}
                        isRTL={isRTL}
                        fullWidth
                        day={day}
                      ></AutoFieldLocal>
                    </Grid>
                  )}
                  {tempoptions?.department && (
                    <Grid item xs={6}>
                      <AutoFieldLocal
                        name="department"
                        title={tempwords?.department}
                        words={words}
                        options={departments.filter(
                          (d: any) => d.depType === 1
                        )}
                        value={departvalue}
                        setSelectValue={setDepartvalue}
                        setSelectError={setDepartError}
                        selectError={departError}
                        refernce={departRef}
                        openAdd={openDepartment}
                        isRTL={isRTL}
                        fullWidth
                        disabled={name === 'departmentId'}
                      ></AutoFieldLocal>
                    </Grid>
                  )}

                  {tempoptions?.resourse && (
                    <Grid item xs={6}>
                      <AutoFieldLocal
                        name="resourse"
                        title={tempwords?.resourse}
                        words={words}
                        options={resourses}
                        value={resovalue}
                        disabled={name === 'resourseId'}
                        setSelectValue={setResovalue}
                        setSelectError={setResoError}
                        selectError={resoError}
                        refernce={resoRef}
                        openAdd={openResourse}
                        isRTL={isRTL}
                        fullWidth
                        day={day}
                      ></AutoFieldLocal>
                    </Grid>
                  )}
                </>
              )}
          </Grid>
        </Grid>
        <Grid item xs={4} style={{ marginTop: 5 }}>
          {tempoptions?.docdescription && (
            <TextField
              name="desc"
              onChange={(e: any) => setDesc(e.target.value)}
              value={desc}
              label={words.notes}
              variant="outlined"
              margin="dense"
              fullWidth
              multiline
              rowsMax={5}
              rows={5}
              style={{ marginTop: 0 }}
            />
          )}
        </Grid>

        <Grid item xs={12}>
          <Box
            style={{
              backgroundColor: '#f4f4f4',
              padding: 10,
              marginTop: 15,
              marginBottom: 15,
              borderRadius: 10,
            }}
          >
            <Box display="flex">
              <ServiceItemForm
                addItem={addItemToList}
                words={words}
                classes={classes}
                user={user}
                isRTL={isRTL}
                setAlrt={setAlrt}
                taskv={task}
                issale={true}
                itemrelations={
                  tempoptions?.purchaseitemrelations ||
                  tempoptions?.itemrelations
                }
              ></ServiceItemForm>
            </Box>
            <Box style={{ marginBottom: 10 }}>
              <ItemsTable
                rows={itemsList}
                editItem={editItemInList}
                removeItem={removeItemFromList}
                isRTL={isRTL}
                words={words}
                user={user}
                itemrelations={
                  tempoptions?.purchaseitemrelations ||
                  tempoptions?.itemrelations
                }
              ></ItemsTable>
            </Box>
          </Box>
        </Grid>
        <Grid item xs={12} md={5}>
          <TextField
            name="discount"
            label={words.discount}
            value={discount.toString()}
            onChange={(e: any) => setDiscount(Number(e.target.value))}
            variant="outlined"
            style={{ width: 200 }}
            margin="dense"
            type="number"
            onFocus={(e) => e.target.select()}
          />
          <Box
            display="flex"
            style={{
              alignItems: 'center',
              justifyContent: 'space-between',
            }}
          >
            <PriceTotal
              amount={totals?.amount}
              total={totals?.total}
              discount={discount}
              words={words}
            ></PriceTotal>
          </Box>
        </Grid>

        <Grid item xs={12} md={7}>
          <PaymentSelect
            words={words}
            isCash={isCash}
            setIsCash={setIsCash}
            paid={paid}
            setPaid={setPaid}
            isRTL={isRTL}
            payAcc={payAcc}
            setPayAcc={setPayAcc}
            payaccounts={cashaccounts}
            isNew={isNew}
            selectpay={true}
          ></PaymentSelect>
          <Box
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              padding: 10,
            }}
          >
            <Typography
              style={{
                direction: 'ltr',
                fontWeight: 'bold',
                color: 'tomato',
              }}
            >
              {moneyFormat(bl)} {isRTL ? 'المتبقي' : 'Balance'}
            </Typography>
            <Typography
              style={{
                direction: 'ltr',
                fontWeight: 'bold',
              }}
            >
              ( {pa} ) {isRTL ? 'مدفوع' : 'Paid'}
            </Typography>
          </Box>
        </Grid>

        <PopupSupplier
          newtext={newtext}
          open={openSupp}
          onClose={onCloseSupplier}
          isNew={true}
          setNewValue={onNewSuppChange}
          row={null}
          addAction={addSupplier}
          editAction={editSupplier}
        ></PopupSupplier>
        <PopupDeprtment
          newtext={newtext}
          open={openDep}
          onClose={onCloseDepartment}
          isNew={true}
          setNewValue={onNewDepartChange}
          row={null}
          addAction={addDepartment}
          editAction={editDepartment}
        ></PopupDeprtment>
        <PopupEmployee
          newtext={newtext}
          open={openEmp}
          onClose={onCloseEmploee}
          isNew={true}
          setNewValue={onNewEmplChange}
          row={null}
          addAction={addEmployee}
          editAction={editEmployee}
        ></PopupEmployee>
        <PopupResourses
          newtext={newtext}
          open={openRes}
          onClose={onCloseResourse}
          isNew={true}
          setNewValue={onNewResoChange}
          row={null}
          addAction={addResourse}
          editAction={editResourse}
        ></PopupResourses>
      </Grid>
    </PopupLayout>
  );
};

export default PopupPurchaseInvoice;
